import CTA from './CTA.component';

export default CTA;